import React from 'react';
import { Form, Dropdown } from 'semantic-ui-react';

const DropdownSelect = ({
  label,
  id,
  choices,
  selectValue,
  onSelectChange
}) => (
  <Form>
    <Form.Field>{label}</Form.Field>
    <Dropdown
      search
      scrolling
      selection
      name={id}
      value={selectValue}
      onChange={onSelectChange}
      options={choices.map(choice => ({
        value: choice.value,
        text: choice.label
      }))}
    />
  </Form>
);

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/PreSection/DropdownSelect.js